export enum SegmentationMode {
  FOREGROUND = 'segmentation-foreground',
  BACKGROUND = 'segmentation-background',
}
